/* eslint-disable class-methods-use-this */
import { context } from 'three/examples/jsm/nodes/shadernode/ShaderNodeBaseElements';
import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import PinText from './PinText';
import {
  PINPICTURE_MAXHEIGHT,
  PINPICTURE_MAXWIDTH,
  PINPICTURE_HEIGHT,
  PINPICTURE_WIDTH,
} from '../Constants';

/**
 * フリー テキスト アイテム モニカ オブジェクト クラス
 */
export default class PinPicture extends PinText {
  private linkWrap: HTMLElement; // 画像部分

  private infoWrap: HTMLElement; // 工事情報部分

  private textWrap: HTMLElement; // テキスト部分

  private textElement: HTMLElement; // テキストビュー


  textGroupViewHtml: HTMLElement;

  private rectX(): number {
    return -PINPICTURE_WIDTH;
  }

  private rectY(): number {
    return PINPICTURE_HEIGHT;
  }

  /**
   * 幅取得
   */
  public getWidth(): number {
    return PINPICTURE_MAXWIDTH;
  }

  /**
   * 高さ取得
   */
  public getHeight(): number {
    return PINPICTURE_MAXHEIGHT;
  }

  constructor(_itemInfo: marietta.webcad.collection.ItemInfoCollection) {
    super(_itemInfo);

    this.addEvents();
  }


  /**
   * ビューの作成
   */
  createImage() {
    this.textView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.textView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_pinText`);
    if (!this.isTextHide) {
      this.textView.style.display = 'block';
    } else {
      this.textView.style.display = 'none';
    }

    this.pinView = document.querySelector('#lib_control_pinpicture svg > g').cloneNode(true) as SVGElement;
    this.pinView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_pin`);

    this.textGroupView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.textGroupView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_pinTextGroup`);
    this.textGroupView.appendChild(this.pinView);
    let viewObj: Element;
    if (this.spt === undefined) {
      viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      viewObj.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}`);
    } else {
      viewObj = this.spt.element;
    }
    viewObj.appendChild(this.textGroupView);

    if (!this.spt) {
      this.spt = new SVGSprite(viewObj);
    }
    this.spt.x = this.itemInfo.x;
    this.spt.y = this.itemInfo.y;
    this.spt.update();

    this.updateTransforms();

    // アプリの状態に応じて表示を変える
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible) {
      this.show();
    } else {
      this.hide();
    }
  }


  /**
   * Translateのアップデート
   */
  updateTransforms() {
    this.spt.x = this.itemInfo.x;
    this.spt.y = this.itemInfo.y;
    if (Number.isNaN(this.spt.scaleX)) this.spt.scaleX = 1;
    if (Number.isNaN(this.spt.scaleY)) this.spt.scaleY = 1;

    this.spt.rotation = 0;
    this.spt.update();

    const pin = new SVGSprite(this.pinView);
    pin.rotation = this.itemInfo.rotation;
    pin.update();
  }

  /**
   * テキスト入力
   */
  private createTextWrapElement(textArray: string[]): HTMLElement {
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    const isPC = !ua.isTablet && !ua.isMobile;

    let textWrap: HTMLElement = document.createElement('div');
    textWrap = this.setTextStyle(textWrap);
    textWrap.style.display = 'block';
    textWrap.setAttribute('class', 'textWrap');

    if (textArray.length === 1 && textArray[0] === '') {
      const textDivElem:HTMLElement = document.createElement('div');
      textDivElem.innerHTML = 'コメントなし';
      textDivElem.style.color = '#b0b0b0';
      textDivElem.style.fontSize = isPC ? '10px' : '10px';
      textWrap.appendChild(textDivElem);
    } else {
      let atag: HTMLElement = document.createElement('a');
      atag.setAttribute('class', 'atag');
      atag.setAttribute('href', '#');
      atag.style.textDecorationLine = 'underline';
      atag = this.setTextStyle(atag);
      atag.innerHTML = textArray.join('<br>');
      atag.addEventListener('pointerdown', (e) => {
        e.stopPropagation();
        this.setDisplay();
      });
      textWrap.appendChild(atag);
    }

    return textWrap;
  }

  /**
   * ディスプレイの切り替え
   */
  private setDisplay() {
    // displayをnoneにして、
    this.linkWrap.style.display = this.linkWrap.style.display == 'none' ? 'block' : 'none';
    this.textWrap.style.display = this.textWrap.style.display == 'none' ? 'block' : 'none';
    // innerの中のテキストをdisplay block
    this.textElement.style.display = this.textElement.style.display == 'none' ? 'block' : 'none';
  }

  /**
   * テキストのスタイル部分
   */
  private setTextStyle(textElement: HTMLElement): HTMLElement {
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    const isPC = !ua.isTablet && !ua.isMobile;
    textElement.style.fontSize = isPC ? '3px' : '10px';
    textElement.style.color = this.itemInfo.text_color;
    textElement.style.fontFamily = marietta.webcad.WebCADGlobal.freeTextFontFamily;

    if (this.itemInfo.is_italic) {
      textElement.style.fontStyle = 'italic';
    }
    if (this.itemInfo.is_bold) {
      textElement.style.fontWeight = 'bold';
    }
    if (this.itemInfo.is_underline) {
      textElement.style.textDecoration = 'underline';
    }
    if (this.itemInfo.is_strike_through) {
      textElement.style.textDecoration = 'line-through';
    }
    textElement.style.textAlign = this.itemInfo.text_alignment;

    // スクロール
    if (this.itemInfo.text_alignment === 'center') {
      const scrollto = (textElement.scrollWidth - textElement.clientWidth) / 2;
      textElement.scrollLeft = scrollto;
    } else if (this.itemInfo.text_alignment === 'right') {
      const scrollto = (textElement.scrollWidth - textElement.clientWidth);
      textElement.scrollLeft = scrollto;
    }

    return textElement;
  }

  /**
   * テキスト入力スタイル設定
   */
  private createTextElement(textArray: string[]) {
    const parentElement: HTMLElement = document.createElement('div');
    parentElement.style.display = 'none';
    parentElement.setAttribute('class', 'textWrapView');

    const btn: HTMLElement = document.createElement('a');
    btn.innerHTML = '×';
    btn.setAttribute('class', 'btn-circle');
    btn.setAttribute('href', '#');
    btn.addEventListener('pointerdown', (e) => {
      e.stopPropagation();
      this.setDisplay();
    });

    let textElement: HTMLElement = document.createElement('div');
    textElement.setAttribute('class', 'textArea');

    textElement = this.setTextStyle(textElement);
    const text = textArray.join('<br>');
    textElement.innerHTML = text;

    parentElement.appendChild(btn);
    parentElement.appendChild(textElement);

    return parentElement;
  }

  private resizeToTarget() {
    if (marietta.webcad.WebCADGlobal.itemManager.itemController !== undefined || marietta.webcad.WebCADGlobal.itemManager.itemController !== null) {
      if (marietta.webcad.WebCADGlobal.itemManager.itemController instanceof marietta.webcad.control.ItemControllerPinText) {
        marietta.webcad.WebCADGlobal.itemManager.itemController.resizeToTarget();
      }
    }
  }

  textShowHide = () => {
    if (!this.isTextHide) {
      this.textShow();
    } else {
      this.textHide();
    }
    this.resizeToTarget();
  }

  /** ピン テキスト部 表示 */
  public textShow() {

  }

  /** ピン テキスト部 非表示 */
  public textHide() {

  }
}
